import { gql } from '@lcs/shared/api';

export const deletePhoneMutation = gql`
   mutation DeletePhone($id: UInt!) {
      deletePhone(id: $id)
   }
`;
